import React from 'react';
import { FaRegUser, FaPencilAlt, FaCheck } from 'react-icons/fa';
import { RiFileCopy2Fill } from 'react-icons/ri';

interface Step {
  label: string;
  icon: React.ReactNode;
}

interface StepIndicatorProps {
  currentStep: number;
}

const steps: Step[] = [
  { label: '본인인증', icon: <FaRegUser /> },
  { label: '약관동의', icon: <RiFileCopy2Fill /> },
  { label: '정보입력', icon: <FaPencilAlt /> },
  { label: '가입완료', icon: <FaCheck /> },
];

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
  return (
    <>
      <div className="absolute top-[60px] mobile:px-4">
        <h1 className='text-center text-MainTextColor Pretendard-Bold text-3xl mobile:text-xl mb-2'>회원가입</h1>
        <p className='text-center text-[#a5a5a5] tracking-wide Pretendard-Regular text-sm mobile:text-xs mb-8 mobile:mb-6'>간편하게 신규가입하고 다양한 혜택을 누려보세요!</p>
        <div className="flex items-center">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center">
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-16 h-16 mobile:w-[44px] mobile:h-[44px] rounded-full flex items-center justify-center
              ${
                currentStep === index + 1
                  ? 'bg-MainColor text-2xl mobile:text-[15px] text-white font-bold'
                  : 'bg-gray-200 text-xl mobile:text-sm text-[#555] font-bold'
              }`}
                >
                  {currentStep === index + 1 ? step.icon : index + 1}
                </div>

                {/* Step Label */}
                <span
                  className={`mt-3 text-base mobile:text-xs ${
                    currentStep === index + 1 ? 'text-black' : 'text-gray-400'
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Step Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-px bg-gray-300 mx-8"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StepIndicator;
